import { renderAsync } from 'docx-preview';
import { END_SUFFIX } from '../ooxml/flatten-sdt';

export interface FieldAnchor {
  readonly id: string;
  readonly start: HTMLElement;
  readonly end: HTMLElement;
}

const RENDER_OPTIONS = {
  inWrapper: true,
  breakPages: true,
  renderHeaders: true,
  renderFooters: true,
  renderFootnotes: true,
  renderEndnotes: true,
  useBase64URL: true,
  experimental: true,
};

export async function renderPreview(
  docx: Blob,
  body: HTMLElement,
  styles: HTMLElement,
  ids: readonly string[],
): Promise<FieldAnchor[]> {
  body.replaceChildren();
  styles.replaceChildren();

  await renderAsync(docx, body, styles, RENDER_OPTIONS);

  return ids.map((id) => toAnchor(body, id)).filter((a): a is FieldAnchor => a !== undefined);
}

function toAnchor(body: HTMLElement, id: string): FieldAnchor | undefined {
  const start = byId(body, id);
  const end = byId(body, id + END_SUFFIX);
  if (!start || !end) {
    return undefined;
  }

  return { id, start, end };
}

function byId(body: HTMLElement, id: string): HTMLElement | undefined {
  return body.querySelector<HTMLElement>(`[id="${id}"]`) ?? undefined;
}
